export const PRACTITIONERS_GROUP_ROUTES = {
    BASE: "/practitioners/*",
    LIST: "/",
};

export const PRACTITIONERS_GROUP_LINKS = {
    BASE: "/app/practitioners",
    LIST: "/app/practitioners",
};